<div class="menu-item-container" *ngIf="screenSize !== 'xs'; else mobileMenu">
    <div class="menu-item-wrapper" [ngClass]="{ active: activeMenuItem === menuItem }" (click)="onMenuItemClick()">
        <div class="title-icon-wrapper">
            <!-- <span class="stcIcon-Mail-F icon" *ngIf="!menuItem.icon"></span> -->
            <ng-container *ngIf="userPath === 'file-management'">
                <img *ngIf="menuItem.img" class="image-img" src="assets/images/{{ menuItem.img }}" alt="menu icon" [ngClass]="menuItem.img" />

                <img *ngIf="menuItem.icon" class="image-icon" src="assets/images/{{ menuItem.icon }}" alt="menu icon" [ngClass]="menuItem.icon" />
            </ng-container>
            <span
                class="menu-title"
                *ngIf="menuItem?.title !== requestTitle && menuItem.title !== generalSettings"
            >
                {{ menuItem?.title | translate }}
            </span>
            <div class="title-container" *ngIf="menuItem.title === requestTitle">
                <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                <span>
                    {{ 'serviceSettings' | translate }}
                </span>
            </div>
            <div class="title-container" *ngIf="menuItem.title === generalSettings">
                <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                <span>
                    {{ 'generalSettings' | translate }}
                </span>
            </div>

            <!-- <div class="title-container" *ngIf="menuItem.title === 'callRecord'">
                <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                <span>
                    {{ 'callRecord' | translate }}
                </span>
            </div>
            <div class="title-container" *ngIf="menuItem.title === 'dashboard'">
                <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                <span>
                    {{ 'dashboard' | translate }}
                </span>
            </div>
            <div class="title-container" *ngIf="menuItem.title === 'callRecordDashboard'">
                <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                <span>
                    {{ 'callRecordDashboard' | translate }}
                </span>
            </div> -->
        </div>
        <span *ngIf="menuItem.count !== undefined" class="counter" [ngClass]="{ coral: menuItem.viewType === returnedRequestView && menuItem.count > 0 }">
            {{ menuItem.count | formatNumberAsText }}
        </span>
        <span *ngIf="menuItem.path" class="contentarrow"><i class="fa fa-angle-left"></i></span>
    </div>
</div>
<ng-template #mobileMenu>
    <div class="all-services-dropdown mobile-menu" [ngClass]="{ heightMenu: !showMobileMenu }">
        <div class="as-dropdown-content" *ngIf="showMobileMenu">
            <a href="javascript:" class="as-dropdown-item" [ngClass]="{ active: activeMenuItem === menuItem }" (click)="onMenuItemClick()">
                <div class="as-dropdown-item-name">
                    <div>
                        <ng-container *ngIf="userPath === 'file-management'">
                            <img *ngIf="menuItem.img" class="image-img" src="assets/images/{{ menuItem.img }}" alt="menu icon" [ngClass]="menuItem.img" />

                            <img *ngIf="menuItem.icon" class="image-icon" src="assets/images/{{ menuItem.icon }}" alt="menu icon" [ngClass]="menuItem.icon" />
                        </ng-container>
                        <span
                            class="menu-title"
                            *ngIf="menuItem.title !== requestTitle && menuItem.title !== generalSettings"
                        >
                            {{ menuItem.title | translate }}
                        </span>
                        <div class="title-container" *ngIf="menuItem.title === requestTitle">
                            <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                            <span>
                                {{ 'serviceSettings' | translate }}
                            </span>
                        </div>
                        <div class="title-container" *ngIf="menuItem.title === generalSettings">
                            <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                            <span>
                                {{ 'generalSettings' | translate }}
                            </span>
                        </div>
                        <!-- <div class="title-container" *ngIf="menuItem.title === 'callRecord'">
                            <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                            <span>
                                {{ 'callRecord' | translate }}
                            </span>
                        </div>
                        <div class="title-container" *ngIf="menuItem.title === 'dashboard'">
                            <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                            <span>
                                {{ 'dashboard' | translate }}
                            </span>
                        </div>
                        <div class="title-container" *ngIf="menuItem.title === 'callRecordDashboard'">
                            <img src="assets/images/Clippathgroup.svg" alt="menu icon" class="image-icon" />
                            <span>
                                {{ 'callRecordDashboard' | translate }}
                            </span>
                        </div> -->
                    </div>
                    <div>
                        <span
                            *ngIf="menuItem.count !== undefined"
                            class="counter dropdown-item-icon"
                            [ngClass]="{ coral: menuItem.viewType === returnedRequestView && menuItem.count > 0 }"
                        >
                            {{ menuItem.count | formatNumberAsText }}
                        </span>
                    </div>
                </div>
            </a>
            <!-- Add more options here -->
        </div>
    </div>
</ng-template>
